export class CategorieFormation {

    static CategorieFormationIds = {
        MASTER: 1,
        DIPLOME: 2,
        AUTRE: 3,
        FC: 4,
        GENERAL: 5,
        INTERNATIONAL: 6
    };

    constructor(
        public id?: number,
        public code?: string,
        public displayed?: boolean,
        public disabled?: boolean,
        public dateCreation?: any,
        public dateModification?: any,
        public ordre?: number
    ) { }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/formation/categorie-formation.model.ts